import { GET_CORRECTION_LIST } from "../../../config/adminUrlConfig";
import { ApiService } from "../../../config/apiServices";

export const getCorrectionByID = (roleType,Id) => {
    return ApiService.get(`${GET_CORRECTION_LIST}/${roleType}/${Id}`);
}